export default class PbError extends Error {
  constructor({
    title = PbError.DEFAULT_TITLE,
    message = PbError.DEFAULT_MESSAGE,
    errors = [],
    page = false,
    status = PbError.DEFAULT_STATUS,
    meta = {},
    ...rest
  } = {}) {
    super(message, rest)
    this.title = title
    this.errors = errors
    this.page = page
    this.status = status
    this.meta = meta

    Object.defineProperty(this, 'message', { enumerable: true })

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }

  static DEFAULT_TITLE = 'Profile Builder error'

  static DEFAULT_MESSAGE = 'An unknown error occured'

  static DEFAULT_STATUS = null
}
